import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import DataTable from 'react-data-table-component';
import { FaRegEdit } from 'react-icons/fa';
import { useCreateBusinessMutation, useGetBusinessQuery } from '../../store/api/businessApi';
import Logo from '../tools/Logo';

const initialUpdateBusiness = {
    id: 0,
    name: '',
    phone: '',
    email: '',
    address: '',
    Integrated: false
}

export default function Business() {

    const [RegisterBusiness] = useCreateBusinessMutation();
    const [updateBusiness, setUpdate] = useState(initialUpdateBusiness)
    // All Exist Business
    const [dataBusiness, setBusinessData] = useState([]);
    // Fetch Business
    const { data, error, isLoading } = useGetBusinessQuery();
    useEffect(() => {
        if (data && Array.isArray(data)) {
            setBusinessData(data)
        }
    }, [data]);


    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <div className="color-text fs-4">Loading...</div>
            </div>
        )
    }

    if (error) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <div className="row">
                    <div className="col-12 opacity-75 bg-light p-4 rounded-3 shadow-md border w-100">
                        <h3 className="text-danger">Opps!!!</h3>
                        <span className="fs-4">
                            A <span className="text-danger fw-bold ">{error.message}</span> has occurred{' '}
                        </span>
                        <div className="fs-5"> The server is shut down 😢</div>
                    </div>
                </div>
            </div>
        )
    }


    const handleUpdate = (updateData) => {
        //console.log(updateData);

        setUpdate({
            id: updateData.id,
            name: updateData.name,
            phone: updateData.phone,
            email: updateData.email,
            address: updateData.address,
            Integrated: updateData.integrated
        })
    }


    // Save Data Business
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(updateBusiness);

        try {
            const response = await RegisterBusiness(updateBusiness);
            if (response.data.status === 200) {
                Swal.fire({
                    title: 'Success!',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: 'Done'
                })
            } else {
                Swal.fire({
                    title: 'error!',
                    text: response.data.message,
                    icon: 'error',
                    confirmButtonText: 'Close'
                });
            }
            setUpdate(initialUpdateBusiness);
        } catch (error) {

            console.log(error);
        }
    };



    const _columns = [
        { name: 'Id', selector: (row) => row.id, sortable: true, center: true },

        {
            name: 'Name',
            selector: (row) => row.name,
            sortable: true,
            center: true
        },
        {
            name: 'Email',
            selector: (row) => row.email,
            sortable: true,
            center: true
        },
        {
            name: 'Phone',
            selector: (row) => row.phone,
            sortable: true,
            center: true
        },
        {
            name: 'Integrated ',
            selector: (row) => row.integrated == true ? (
                <Logo _width={20} name={'../../../image/icons/done.svg'} _height={20} _marginLeft={0} />
            ) : (
                <Logo _width={26} name={'../../../image/icons/cancel.svg'} _height={26} _marginLeft={0} />
            ),
            sortable: true,
            center: true
        },
        {
            name: 'Create At',
            selector: (row) => row.created,
            sortable: true,
            center: true
        },
        {
            name: 'Updated At',
            selector: (row) => row.updated,
            sortable: true,
            center: true
        },

        {
            name: 'Actions',
            cell: (row) => (
                <>
                    <button
                        style={{ background: '#1a2131' }}
                        className="btn btn-success me-3 border-0  text-white"
                        data-bs-toggle="modal"
                        data-bs-target="#modal-fromleft-update"
                        onClick={() => handleUpdate(row)}
                    >
                        <FaRegEdit />
                    </button>

                </>
            ),
            center: true
        }
    ];


    const canSave = [updateBusiness.name, updateBusiness.phone, updateBusiness.email, updateBusiness.address].every(Boolean)

    return (
        <>

            <div className='block-content p-5'>
                <div className="row">
                    <h4>Business Information</h4>
                </div>

                <div className="row  mt-4">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12 col-12">
                        <DataTable
                            pointerOnHover
                            className="rounded-3 "
                            columns={_columns}
                            data={dataBusiness}
                            striped
                            highlightOnHover
                        />
                    </div>
                    <div className="row ">

                    </div>
                </div>


            </div>


            <div
                class="modal fade"
                id="modal-fromleft-update"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-fromleft"
                aria-hidden="true"
            >
                <div class="modal-dialog modal-dialog-fromleft" role="document">
                    <div class="modal-content">
                        <div class="block block-themed block-transparent mb-0">
                            <div class="block-header1 d-flex p-3 bg-yellows">
                                <h3 class="block-title text-white">Update Business</h3>
                                <div class="block-options">
                                    <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                        <i class="si si-close text-white"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="block-content">
                                <form encType="multipart/form-data">
                                    <div className="row">
                                        <div className="col-sm-12 hover">
                                            <div className="mb-3">
                                                <div className="row">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                                        Business Name
                                                    </label>
                                                </div>
                                                <input
                                                    type="text"
                                                    style={{ height: '45px' }}
                                                    className="form-control"
                                                    id="exampleFormControlInput1"
                                                    placeholder="name"
                                                    value={updateBusiness.name}
                                                    onChange={(e) => setUpdate({ ...updateBusiness, name: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-12 hover">
                                            <div className="mb-3">
                                                <div className="row">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                                        Business Phone
                                                    </label>
                                                </div>
                                                <input
                                                    type="text"
                                                    style={{ height: '45px' }}
                                                    className="form-control"
                                                    id="exampleFormControlInput1"
                                                    placeholder="phone"
                                                    value={updateBusiness.phone}
                                                    onChange={(e) => setUpdate({ ...updateBusiness, phone: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 hover">
                                            <div className="mb-3">
                                                <div className="row">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                                        Business Email
                                                    </label>
                                                </div>
                                                <input
                                                    type="text"
                                                    style={{ height: '45px' }}
                                                    className="form-control"
                                                    id="exampleFormControlInput1"
                                                    placeholder="username"
                                                    value={updateBusiness.email}
                                                    onChange={(e) => setUpdate({ ...updateBusiness, email: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 hover">
                                            <div className="mb-3">
                                                <div className="row">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label text-start">
                                                        Business Address
                                                    </label>
                                                </div>
                                                <input
                                                    type="text"
                                                    style={{ height: '45px' }}
                                                    className="form-control"
                                                    id="exampleFormControlInput1"
                                                    placeholder="address"
                                                    value={updateBusiness.address}
                                                    onChange={(e) => setUpdate({ ...updateBusiness, address: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        {/* <div className="col-md-12 hover">
                                            <div className="mb-3">
                                                <div className="row">
                                                    <label
                                                        htmlFor="SelectStatus"
                                                        className="form-label text-start"
                                                    >
                                                        Select Integration Status
                                                    </label>
                                                </div>
                                                <select
                                                    className="form-select"
                                                    style={{ height: '45px' }}
                                                    aria-label="Default select example"
                                                    id="SelectStatus"
                                                    onChange={(e) => setUpdate({ ...updateBusiness, Integrated: e.target.value === 'true' })}
                                                    value={updateBusiness.Integrated ? 'true' : 'false'}
                                                >
                                                    <option value="">Select Integration Status</option>
                                                    <option value={true}>Integrated</option>
                                                    <option value={false}>Not Integrated</option>
                                                </select>

                                            </div>
                                        </div> */}

                                    </div>



                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                                            Close
                                        </button>
                                        <input
                                            type="submit"
                                            class="btn btn-primary "
                                            data-BS-dismiss="modal"
                                            onClick={handleSubmit}
                                            disabled={!canSave}
                                            value="Save changes"
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
